export const IconHome = () => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth=".6"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.55 2.532a2.25 2.25 0 0 1 2.9 0l6.75 5.692c.507.428.8 1.057.8 1.72v9.803a1.75 1.75 0 0 1-1.75 1.75h-3.5a1.75 1.75 0 0 1-1.75-1.75v-5.5a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25v5.5a1.75 1.75 0 0 1-1.75 1.75h-3.5A1.75 1.75 0 0 1 3 19.747V9.944c0-.663.293-1.292.8-1.72l6.75-5.692Zm1.933 1.147a.75.75 0 0 0-.966 0L4.767 9.37a.75.75 0 0 0-.267.573v9.803c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-5.5c0-.967.784-1.75 1.75-1.75h3.5c.966 0 1.75.783 1.75 1.75v5.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25V9.944a.75.75 0 0 0-.267-.573l-6.75-5.692Z"
      fill="currentColor"
    />
  </svg>
)
export function IconGlobe() {
  return (
    // <svg
    //   viewBox="0 0 24 24"
    //   stroke="currentColor"
    //   strokeWidth="2"
    //   fill="none"
    //   strokeLinecap="round"
    //   strokeLinejoin="round">
    //   <circle cx="12" cy="12" r="10"></circle>
    //   <line x1="2" y1="12" x2="22" y2="12"></line>
    //   <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    // </svg>

    <svg viewBox="0 0 24 24" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm.83-2.473c-.36.381-.641.473-.83.473-.189 0-.47-.091-.83-.473-.363-.384-.736-.992-1.07-1.827-.417-1.043-.743-2.361-.929-3.856.904.102 1.853.156 2.829.156.976 0 1.925-.054 2.829-.156-.186 1.495-.512 2.813-.929 3.856-.334.835-.707 1.444-1.07 1.827zm2.156-7.717c-.933.123-1.937.19-2.986.19-1.049 0-2.053-.067-2.987-.19A24.277 24.277 0 0 1 9 12c0-2.667.434-5.035 1.1-6.7.334-.835.707-1.443 1.07-1.827.36-.381.641-.473.83-.473.189 0 .47.091.83.473.363.384.736.992 1.07 1.827.666 1.665 1.1 4.033 1.1 6.7 0 .273-.005.544-.014.81zm1.891 1.706c-.185 1.87-.575 3.563-1.12 4.926-.128.32-.267.627-.416.918a9.009 9.009 0 0 0 5.603-7.35c-.598.372-1.3.692-2.071.959a16.62 16.62 0 0 1-1.996.547zm3.986-4.088c-.123.203-.344.446-.71.707-.47.337-1.12.662-1.935.944-.379.132-.788.252-1.222.359C17 12.292 17 12.146 17 12c0-2.856-.461-5.488-1.243-7.442-.128-.32-.267-.627-.416-.918a9.014 9.014 0 0 1 5.522 6.788zm-13.86 2.01A26.392 26.392 0 0 1 7 12c0-2.856.461-5.488 1.243-7.442.128-.32.267-.627.416-.918a9.014 9.014 0 0 0-5.522 6.788l.019.03c.36.56 1.33 1.22 2.97 1.735.28.088.572.17.878.245zm-3.947.573A9.009 9.009 0 0 0 8.66 20.36c-.15-.29-.288-.598-.416-.918-.545-1.363-.935-3.057-1.12-4.926a17.221 17.221 0 0 1-1.596-.415c-.908-.285-1.758-.647-2.47-1.09z"></path>
    </svg>
  )
}
export function IconImage() {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth=".6"
      stroke="currentColor">
      <path
        d="M18 11C18 9.067 19.567 7.5 21.5 7.5C23.433 7.5 25 9.067 25 11C25 12.933 23.433 14.5 21.5 14.5C19.567 14.5 18 12.933 18 11ZM21.5 9.5C20.6716 9.5 20 10.1716 20 11C20 11.8284 20.6716 12.5 21.5 12.5C22.3284 12.5 23 11.8284 23 11C23 10.1716 22.3284 9.5 21.5 9.5ZM3 7.5C3 5.01472 5.01472 3 7.5 3H24.5C26.9853 3 29 5.01472 29 7.5V24.5C29 26.9853 26.9853 29 24.5 29H7.5C5.01472 29 3 26.9853 3 24.5V7.5ZM7.5 5C6.11929 5 5 6.11929 5 7.5V24.5C5 24.7891 5.04909 25.0668 5.13938 25.3252L14.2323 16.2322C15.2086 15.2559 16.7915 15.2559 17.7678 16.2322L26.8607 25.325C26.9509 25.0667 27 24.7891 27 24.5V7.5C27 6.11929 25.8807 5 24.5 5H7.5ZM25.4994 26.7922L16.3536 17.6464C16.1584 17.4512 15.8418 17.4512 15.6465 17.6464L6.50069 26.7923C6.80674 26.9259 7.14471 27 7.5 27H24.5C24.8553 27 25.1933 26.9259 25.4994 26.7922Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconVideo() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 8.96533C9.5 8.48805 9.5 8.24941 9.59974 8.11618C9.68666 8.00007 9.81971 7.92744 9.96438 7.9171C10.1304 7.90525 10.3311 8.03429 10.7326 8.29239L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.6729L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 15.9999 9.59974 15.8838C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96533Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function IconMusic() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 18V6.35537C9 5.87383 9 5.63306 9.0876 5.43778C9.16482 5.26565 9.28917 5.11887 9.44627 5.0144C9.62449 4.89588 9.86198 4.8563 10.337 4.77714L19.137 3.31047C19.7779 3.20364 20.0984 3.15023 20.3482 3.243C20.5674 3.32441 20.7511 3.48005 20.8674 3.68286C21 3.91398 21 4.23889 21 4.8887V16M9 18C9 19.6568 7.65685 21 6 21C4.34315 21 3 19.6568 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18ZM21 16C21 17.6568 19.6569 19 18 19C16.3431 19 15 17.6568 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const IconPeople = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 15.8369C19.4559 16.5683 20.7041 17.742 21.6152 19.2096C21.7956 19.5003 21.8858 19.6456 21.917 19.8468C21.9804 20.2558 21.7008 20.7585 21.3199 20.9204C21.1325 21 20.9216 21 20.5 21M16 11.5322C17.4817 10.7959 18.5 9.26686 18.5 7.5C18.5 5.73314 17.4817 4.20411 16 3.46776M14 7.5C14 9.98528 11.9852 12 9.49996 12C7.01468 12 4.99996 9.98528 4.99996 7.5C4.99996 5.01472 7.01468 3 9.49996 3C11.9852 3 14 5.01472 14 7.5ZM2.55919 18.9383C4.1535 16.5446 6.66933 15 9.49996 15C12.3306 15 14.8464 16.5446 16.4407 18.9383C16.79 19.4628 16.9646 19.725 16.9445 20.0599C16.9289 20.3207 16.7579 20.64 16.5495 20.7976C16.2819 21 15.9138 21 15.1776 21H3.82232C3.08613 21 2.71804 21 2.4504 20.7976C2.24201 20.64 2.07105 20.3207 2.05539 20.0599C2.03529 19.725 2.20992 19.4628 2.55919 18.9383Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

  // <svg xmlns="http://www.w3.org/2000/svg" viewBox="3 5 18 14">
  //   <g
  //     fillRule="evenodd"
  //     clipRule="evenodd"
  //     strokeWidth="0"
  //     stroke="currentColor"
  //     fill="currentColor">
  //     <path d="M12 18.561zc.647-.18.999-.791.999-1.463V16.5c0-1.174-.333-2.198-1-2.971-.667.773-1 1.797-1 2.971v.598c0 .672.352 1.284.999 1.463zm1.655-6.17c.433.542.753 1.144.972 1.782A5 5 0 0 1 16 14c1.297 0 2 .36 2.368.711.361.346.632.905.632 1.789v.245c-.633.13-1.603.255-3 .255q-.541 0-1-.023v.121c0 .604-.154 1.267-.488 1.854q.667.046 1.488.048c1.953 0 3.228-.224 4.001-.439.647-.18.999-.791.999-1.463V16.5c0-2.625-1.667-4.5-5-4.5-.904 0-1.686.138-2.345.392zM16 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
  //     <path d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0m0 8.5v.245c-.633.13-1.603.255-3 .255s-2.368-.124-3-.255V16.5c0-.884.27-1.443.632-1.789C6 14.36 6.703 14 8 14s2 .36 2.368.711c.361.346.632.905.632 1.789m2 .598V16.5c0-2.625-1.667-4.5-5-4.5s-5 1.875-5 4.5v.598c0 .672.352 1.284.999 1.463C4.772 18.776 6.047 19 8 19s3.228-.224 4.001-.439c.647-.18.999-.791.999-1.463" />
  //   </g>
  // </svg>
)
export function IconSparkle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      strokeWidth=".1"
      stroke="currentColor"
      fill="currentColor">
      <path
        fillRule="evenodd"
        d="m8 12.386 1.364-3.022L12.386 8 9.364 6.636 8 3.614 6.636 6.636 3.613 8l3.023 1.364zm-2.372-2.014L1.796 8.643c-.617-.206-.617-1.08 0-1.286l3.832-1.729 1.729-3.831c.206-.618 1.08-.618 1.286 0l1.729 3.831 3.831 1.73c.618.205.618 1.08 0 1.285l-3.831 1.729-1.73 3.832c-.205.617-1.08.617-1.285 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}
export function IconSparkle2() {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M8.664 15.735c.245.173.537.265.836.264v-.004a1.442 1.442 0 0 0 1.327-.872l.613-1.864a2.872 2.872 0 0 1 1.817-1.812l1.778-.578a1.443 1.443 0 0 0-.052-2.74l-1.755-.57a2.876 2.876 0 0 1-1.822-1.823l-.578-1.777a1.446 1.446 0 0 0-2.732.022l-.583 1.792a2.877 2.877 0 0 1-1.77 1.786l-1.777.571a1.444 1.444 0 0 0 .017 2.734l1.754.569a2.887 2.887 0 0 1 1.822 1.826l.578 1.775c.099.283.283.528.527.7Zm-.374-4.25a4.054 4.054 0 0 0-.363-.413h.003a4.394 4.394 0 0 0-1.72-1.063l-1.6-.508 1.611-.524a4.4 4.4 0 0 0 1.69-1.065 4.448 4.448 0 0 0 1.041-1.708l.515-1.582.516 1.587a4.374 4.374 0 0 0 2.781 2.773l1.62.522-1.59.515a4.379 4.379 0 0 0-2.774 2.775l-.515 1.582-.515-1.585a4.368 4.368 0 0 0-.7-1.306Zm8.041 9.297a1.123 1.123 0 0 1-.41-.549l-.328-1.007a1.293 1.293 0 0 0-.821-.823l-.991-.323A1.148 1.148 0 0 1 13 16.997a1.143 1.143 0 0 1 .771-1.08l1.006-.326a1.3 1.3 0 0 0 .8-.819l.324-.992a1.143 1.143 0 0 1 2.157-.021l.329 1.014a1.3 1.3 0 0 0 .82.816l.992.323a1.141 1.141 0 0 1 .039 2.165l-1.014.329a1.3 1.3 0 0 0-.818.822l-.322.989c-.078.23-.226.43-.425.57a1.14 1.14 0 0 1-1.328-.005Zm-1.03-3.783A2.789 2.789 0 0 1 17 18.708a2.794 2.794 0 0 1 1.7-1.7 2.813 2.813 0 0 1-1.718-1.708A2.806 2.806 0 0 1 15.3 17Z" />
    </svg>
  )
}
export const IconMetaverse = () => (
  <svg fill="currentColor" viewBox="0 0 24 24">
    <path
      d="M8 6V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h1.381c2.203 0 4.146 1.451 4.412 3.638q.033.27.062.553A2 2 0 0 1 23 12v2a2 2 0 0 1-1.145 1.809q-.03.283-.062.553C21.527 18.549 19.584 20 17.381 20h-1.145a3 3 0 0 1-2.408-1.212l-1.03-1.387a.994.994 0 0 0-1.596 0l-1.03 1.387A3 3 0 0 1 7.764 20H6.618c-2.202 0-4.145-1.451-4.411-3.638q-.033-.27-.062-.553A2 2 0 0 1 1 14v-2a2 2 0 0 1 1.145-1.809q.03-.283.062-.553C2.473 7.451 4.416 6 6.618 6zm2-1h4v1h-4zM6.618 8c-1.373 0-2.303.867-2.426 1.88A26 26 0 0 0 4 13c0 1.143.08 2.202.192 3.12C4.315 17.133 5.245 18 6.618 18h1.146a1 1 0 0 0 .802-.404l1.03-1.387a2.994 2.994 0 0 1 4.808 0l1.03 1.387a1 1 0 0 0 .802.404h1.145c1.374 0 2.304-.867 2.427-1.88.112-.918.192-1.977.192-3.12s-.08-2.202-.192-3.12C19.685 8.867 18.755 8 17.381 8z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)
export function IconSettings() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      strokeWidth=".3"
      stroke="currentColor"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.568 3.5a1 1 0 0 0-.863.494l-.811 1.381A3 3 0 0 1 7.33 6.856l-1.596.013a1 1 0 0 0-.858.501l-.44.761a1 1 0 0 0-.003.992l.792 1.4a3 3 0 0 1 0 2.954l-.792 1.4a1 1 0 0 0 .004.992l.439.76a1 1 0 0 0 .858.502l1.596.013a3 3 0 0 1 2.564 1.48l.811 1.382a1 1 0 0 0 .863.494h.87a1 1 0 0 0 .862-.494l.812-1.381a3 3 0 0 1 2.563-1.481l1.596-.013a1 1 0 0 0 .859-.501l.439-.761a1 1 0 0 0 .004-.992l-.793-1.4a3 3 0 0 1 0-2.953l.793-1.401a1 1 0 0 0-.004-.992l-.439-.76a1 1 0 0 0-.859-.502l-1.596-.013a3 3 0 0 1-2.563-1.48L13.3 3.993a1 1 0 0 0-.862-.494zM8.98 2.981A3 3 0 0 1 11.568 1.5h.87a3 3 0 0 1 2.588 1.481l.81 1.382a1 1 0 0 0 .855.494l1.597.013a3 3 0 0 1 2.575 1.502l.44.76a3 3 0 0 1 .011 2.975l-.792 1.4a1 1 0 0 0 0 .985l.792 1.401a3 3 0 0 1-.012 2.974l-.439.761a3 3 0 0 1-2.575 1.503l-1.597.012a1 1 0 0 0-.854.494l-.811 1.382a3 3 0 0 1-2.588 1.481h-.87a3 3 0 0 1-2.588-1.481l-.811-1.382a1 1 0 0 0-.855-.494l-1.596-.012a3 3 0 0 1-2.576-1.503l-.439-.76a3 3 0 0 1-.012-2.975l.793-1.4a1 1 0 0 0 0-.985l-.793-1.4a3 3 0 0 1 .012-2.975l.44-.761A3 3 0 0 1 5.717 4.87l1.596-.013a1 1 0 0 0 .855-.494z"
        clipRule="evenodd"></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.003 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M8.502 12a3.5 3.5 0 1 1 7 .001 3.5 3.5 0 0 1-7-.001"
        clipRule="evenodd"></path>
    </svg>
  )
}
export function IconLocation() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.2"
      stroke="currentColor">
      <path
        d="M14 2.25C19.3848 2.25 23.75 6.61522 23.75 12C23.75 16.1196 20.8554 20.6093 15.1402 25.5179C14.4844 26.0811 13.5156 26.0811 12.8572 25.5156L12.4794 25.1881C7.01712 20.4089 4.25 16.0278 4.25 12C4.25 6.61522 8.61522 2.25 14 2.25ZM14 3.75C9.44365 3.75 5.75 7.44365 5.75 12C5.75 15.5021 8.2984 19.5368 13.4645 24.057L13.8371 24.3799C13.9308 24.4604 14.0692 24.4604 14.1629 24.3799C19.5789 19.7283 22.25 15.5853 22.25 12C22.25 7.44365 18.5563 3.75 14 3.75ZM14 8.25C16.0711 8.25 17.75 9.92893 17.75 12C17.75 14.0711 16.0711 15.75 14 15.75C11.9289 15.75 10.25 14.0711 10.25 12C10.25 9.92893 11.9289 8.25 14 8.25ZM14 9.75C12.7574 9.75 11.75 10.7574 11.75 12C11.75 13.2426 12.7574 14.25 14 14.25C15.2426 14.25 16.25 13.2426 16.25 12C16.25 10.7574 15.2426 9.75 14 9.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconSend() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="m 14.619135,3.585383 a 2.0003082,2.0003082 0 0 1 2.828081,0 l 9.000512,9.000508 a 2.0003082,2.0003082 0 0 1 -2.828082,2.828086 L 18.033486,9.8278111 V 27.001059 a 2.0003084,2.0003084 0 0 1 -4.000616,0 V 9.8278111 L 8.4467091,15.413977 A 2.0003082,2.0003082 0 1 1 5.6186244,12.585891 Z"
      />
    </svg>
  )
}
export function IconCart() {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 2.7368404,20.526319 V 7.7894746 H 21.26316 V 20.526319 a 2.3157899,2.3157899 0 0 1 -2.31579,2.315789 H 5.0526302 A 2.3157899,2.3157899 0 0 1 2.7368404,20.526319"
        fill="none"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.2"
        d="M 8.5263153,11.26316 V 6.6315796 A 3.4736848,3.4736848 0 0 1 12,3.1578948 v 0 a 3.4736848,3.4736848 0 0 1 3.473685,3.4736848 V 11.26316"
        fill="none"
      />
    </svg>

    // <svg
    //   fill="currentColor"
    //   viewBox="0 0 24 24"
    //   stroke="currentColor"
    //   strokeWidth=".15">
    //   <path
    //     fillRule="evenodd"
    //     d="M10 5a2 2 0 1 1 4 0v1h-4zM8 8v2a1 1 0 1 0 2 0V8h4v2a1 1 0 1 0 2 0V8h.624a1 1 0 0 1 .973.771l.34 1.442A40 40 0 0 1 19 19.375V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-.625c0-3.085.357-6.16 1.063-9.162l.34-1.442A1 1 0 0 1 7.376 8zm0-2V5a4 4 0 1 1 8 0v1h.624a3 3 0 0 1 2.92 2.313l.34 1.442A42 42 0 0 1 21 19.375V20a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-.625a42 42 0 0 1 1.116-9.62l.34-1.442A3 3 0 0 1 7.376 6z"
    //     clipRule="evenodd"
    //   />
    // </svg>
  )
}
export function IconCode() {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    //   <path
    //     fill="currentColor"
    //     fillRule="evenodd"
    //     d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm1.293 4.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414L8.586 12l-1.293-1.293a1 1 0 0 1 0-1.414M12 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
    //     clipRule="evenodd"
    //   />
    // </svg>

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth=".8"
      stroke="currentColor">
      <path
        d="M8.06562 18.9434L14.5656 4.44339C14.7351 4.06542 15.1788 3.89637 15.5568 4.0658C15.9033 4.22112 16.0742 4.60695 15.9698 4.96131L15.9344 5.05698L9.43438 19.557C9.26495 19.935 8.82118 20.104 8.44321 19.9346C8.09673 19.7793 7.92581 19.3934 8.03024 19.0391L8.06562 18.9434L14.5656 4.44339L8.06562 18.9434ZM2.21967 11.4699L6.46967 7.21986C6.76256 6.92696 7.23744 6.92696 7.53033 7.21986C7.7966 7.48612 7.8208 7.90279 7.60295 8.1964L7.53033 8.28052L3.81066 12.0002L7.53033 15.7199C7.82322 16.0127 7.82322 16.4876 7.53033 16.7805C7.26406 17.0468 6.8474 17.071 6.55379 16.8531L6.46967 16.7805L2.21967 12.5305C1.9534 12.2642 1.9292 11.8476 2.14705 11.554L2.21967 11.4699L6.46967 7.21986L2.21967 11.4699ZM16.4697 7.21986C16.7359 6.95359 17.1526 6.92938 17.4462 7.14724L17.5303 7.21986L21.7803 11.4699C22.0466 11.7361 22.0708 12.1528 21.8529 12.4464L21.7803 12.5305L17.5303 16.7805C17.2374 17.0734 16.7626 17.0734 16.4697 16.7805C16.2034 16.5142 16.1792 16.0976 16.3971 15.804L16.4697 15.7199L20.1893 12.0002L16.4697 8.28052C16.1768 7.98762 16.1768 7.51275 16.4697 7.21986Z"
        fill="currentColor"></path>
    </svg>
  )
}
export const IconShield = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1.5"
    stroke="currentColor">
    <path
      d="M15.4453 2.16795C15.7812 1.94402 16.2188 1.94402 16.5547 2.16795C19.4707 4.11195 23.3149 6.0265 28.0995 6.50496C28.6107 6.55608 29 6.98625 29 7.5V16C29 19.8796 26.8761 23.1691 24.2989 25.5462C21.7274 27.9179 18.5623 29.517 16.1843 29.9629L16 29.9974L15.8157 29.9629C13.4377 29.517 10.2726 27.9179 7.70115 25.5462C5.12389 23.1691 3 19.8796 3 16V7.5C3 6.98625 3.38929 6.55608 3.9005 6.50496C8.68509 6.0265 12.5293 4.11195 15.4453 2.16795ZM5 8.38831V16C5 19.1204 6.71495 21.9157 9.05712 24.076C11.3319 26.1742 14.0638 27.5451 16 27.9601C17.9362 27.5451 20.6681 26.1742 22.9429 24.076C25.285 21.9157 27 19.1204 27 16V8.38831C22.5038 7.7717 18.8344 6.00808 16 4.19443C13.1656 6.00808 9.49618 7.7717 5 8.38831Z"
      fill="currentColor"
    />
  </svg>
)
export function IconMic() {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 32 32"
    //   fill="currentColor">
    //   <path
    //     d="m16,20.21c2.8,0,5.05-2.26,5.05-5.05V5.05c0-2.8-2.26-5.05-5.05-5.05s-5.05,2.26-5.05,5.05v10.11c0,2.8,2.26,5.05,5.05,5.05Zm-1.68-15.16c0-.93.76-1.68,1.68-1.68s1.68.76,1.68,1.68v10.11c0,.94-.74,1.68-1.68,1.68s-1.68-.76-1.68-1.68V5.05Zm11.94,10.11h0c.87,0,1.54.78,1.41,1.64-.77,4.99-4.99,8.93-9.98,9.68v4.1c0,.79-.64,1.43-1.43,1.43h-.51c-.79,0-1.43-.64-1.43-1.43v-4.1c-4.99-.75-9.21-4.69-9.98-9.68-.13-.86.54-1.64,1.41-1.64h0c.71,0,1.31.53,1.41,1.23.63,4.39,4.58,7.36,8.84,7.36s8.21-2.97,8.84-7.36c.1-.7.7-1.23,1.41-1.23Z"
    //     stroke="currentColor"
    //     strokeWidth=".2"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>

    // <svg xmlns="http://www.w3.org/2000/svg" viewBox="4 2 16 20">
    //   <g clip-path="url(#a)">
    //     <path
    //       fill-rule="evenodd"
    //       d="M12 2c-1.792 0-3.396 1.148-3.707 2.913A18 18 0 0 0 8 8c0 1.075.128 2.15.293 3.087C8.603 12.852 10.208 14 12 14s3.396-1.148 3.707-2.913C15.872 10.15 16 9.075 16 8s-.128-2.15-.293-3.087C15.397 3.148 13.792 2 12 2m2 6c0-.925-.111-1.879-.263-2.74C13.622 4.602 12.984 4 12 4s-1.622.603-1.737 1.26A16 16 0 0 0 10 8c0 .925.111 1.879.263 2.74.115.657.753 1.26 1.737 1.26s1.622-.603 1.737-1.26C13.889 9.88 14 8.926 14 8"
    //       clip-rule="evenodd"
    //     />
    //     <path d="M12 16c2.753 0 5.17-1.52 5.725-3.918.17-.736.275-1.45.275-2.082a1 1 0 1 1 2 0c0 .835-.135 1.709-.326 2.534-.746 3.22-3.639 5.076-6.674 5.41V20h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-2.055c-3.035-.335-5.928-2.191-6.674-5.412C4.136 11.71 4 10.835 4 10a1 1 0 0 1 2 0c0 .633.104 1.346.275 2.082C6.83 14.48 9.247 16 12 16" />
    //   </g>
    // </svg>

    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      version="1.1"
      id="svg2"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg">
      <defs id="defs2" />
      <g transform="matrix(1.2,0,0,1.2,-2.4,-2.4)" id="g2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m 8,6 c 0,-2.20914 1.79086,-4 4,-4 2.2091,0 4,1.79086 4,4 v 5 c 0,2.2091 -1.7909,4 -4,4 -2.20914,0 -4,-1.7909 -4,-4 z m 4,-2 c -1.1046,0 -2,0.89543 -2,2 v 5 c 0,1.1046 0.8954,2 2,2 1.1046,0 2,-0.8954 2,-2 V 6 C 14,4.89543 13.1046,4 12,4 Z"
          id="path1"
        />
        <path
          d="m 5,9 c 0.55228,0 1,0.44772 1,1 v 1 c 0,3.3137 2.68629,6 6,6 3.3137,0 6,-2.6863 6,-6 v -1 c 0,-0.55228 0.4477,-1 1,-1 0.5523,0 1,0.44772 1,1 v 1 c 0,4.0803 -3.0547,7.4471 -7.0019,7.9383 C 12.9994,18.9587 13,18.9793 13,19 v 2 c 0,0.5523 -0.4477,1 -1,1 -0.5523,0 -1,-0.4477 -1,-1 v -2 c 0,-0.0207 6e-4,-0.0413 0.0019,-0.0617 C 7.05466,18.4471 4,15.0803 4,11 V 10 C 4,9.44772 4.44772,9 5,9 Z"
          id="path2"
        />
      </g>
    </svg>
  )
}
export function IconTrending() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  )
}
export const IconStories = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth=".2">
    <path d="M4.774 1.378a.75.75 0 01.538-.915 6.75 6.75 0 013.375 0 .75.75 0 11-.375 1.452 5.257 5.257 0 00-2.625 0 .75.75 0 01-.913-.537zm-2.59.893A6.756 6.756 0 00.496 5.193a.75.75 0 101.446.4 5.25 5.25 0 011.312-2.272.75.75 0 10-1.07-1.05zM1.94 8.405a.75.75 0 00-1.445.4 6.75 6.75 0 001.688 2.925.75.75 0 001.066-1.052 5.25 5.25 0 01-1.309-2.273zm6.371 3.679a5.25 5.25 0 01-2.625 0 .75.75 0 10-.375 1.452 6.75 6.75 0 003.375 0 .75.75 0 10-.375-1.452zm4.67-4.201a.75.75 0 00-.92.523 5.25 5.25 0 01-1.312 2.272.75.75 0 001.07 1.051 6.763 6.763 0 001.688-2.923.75.75 0 00-.526-.923zm-.923-2.288a.75.75 0 001.445-.402 6.75 6.75 0 00-1.687-2.923.75.75 0 10-1.067 1.051 5.25 5.25 0 011.309 2.274z"></path>
  </svg>
)
export function IconBook() {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth=".2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="m 13.49007,4.4716995 a 1.0820024,1.0820024 0 0 0 -0.98354,0 L 2.1647506,9.7486257 1.1801284,7.8204971 11.524072,2.5435712 a 3.2460074,3.2460074 0 0 1 2.949538,0 l 10.343944,5.2769259 a 2.1423648,2.1423648 0 0 1 1.165317,2.1856459 v 6.253973 a 1.082003,1.082003 0 1 1 -2.164006,0 v -4.094297 l -2.199711,1.076592 v 4.429718 a 3.2460074,3.2460074 0 0 1 -1.7074,2.85865 l -5.374306,2.892193 a 3.2460074,3.2460074 0 0 1 -3.077215,0 L 6.0859275,20.530779 A 3.2460074,3.2460074 0 0 1 4.3785276,17.672129 V 13.242411 L 1.2115065,11.691902 C -0.38985714,10.90745 -0.40716918,8.6309169 1.1801284,7.8204971 L 2.1647506,9.7486257 12.52276,14.822135 a 1.0820024,1.0820024 0 0 0 0.952162,0 L 23.818865,9.7562002 V 9.7410552 Z M 6.5436145,14.302774 v 3.369355 a 1.0820024,1.0820024 0 0 0 0.5680513,0.952163 l 5.3743062,2.893274 a 1.0820024,1.0820024 0 0 0 1.025738,0 l 5.374306,-2.892192 a 1.0820024,1.0820024 0 0 0 0.569134,-0.952163 v -3.371519 l -5.028065,2.462638 a 3.2460074,3.2460074 0 0 1 -2.856487,0 z"
      />
    </svg>
  )
}
export function IconBriefcase() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="currentColor"
      strokeWidth="2.1"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>
  )
}
export const IconGames = () => (
  // <svg
  //   fill="currentColor"
  //   strokeWidth=".6"
  //   stroke="currentColor"
  //   viewBox="0 0 24 24"
  //   xmlns="http://www.w3.org/2000/svg">
  //   <path d="M14.998 5a7 7 0 0 1 .24 13.996l-.24.004H9.002a7 7 0 0 1-.24-13.996L9.001 5h5.996Zm0 1.5H9.002a5.5 5.5 0 0 0-.221 10.996l.221.004h5.996a5.5 5.5 0 0 0 .221-10.996l-.221-.004ZM8 9a.75.75 0 0 1 .75.75v1.498h1.5a.75.75 0 0 1 0 1.5h-1.5v1.502a.75.75 0 0 1-1.5 0v-1.502h-1.5a.75.75 0 1 1 0-1.5h1.5V9.75A.75.75 0 0 1 8 9Zm6.75 3.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm2-3.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" />
  // </svg>

  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="currentColor"
    strokeWidth="6"
    stroke="currentColor">
    <path d="M176 112h-24a8 8 0 010-16h24a8 8 0 010 16zm-72-16h-8v-8a8 8 0 00-16 0v8h-8a8 8 0 000 16h8v8a8 8 0 0016 0v-8h8a8 8 0 000-16zm137.48 104.65a36 36 0 01-54.94 4.81c-.12-.12-.24-.24-.35-.37L146.48 160h-37l-39.67 45.09-.35.37A36.08 36.08 0 0144 216a36 36 0 01-35.44-42.25.68.68 0 010-.14l16.37-84.09A59.88 59.88 0 0183.89 40H172a60.08 60.08 0 0159 49.25v.18l16.37 84.17a.68.68 0 010 .14 35.74 35.74 0 01-5.89 26.91zM172 144a44 44 0 000-88H83.89a43.9 43.9 0 00-43.21 36.37v.13L24.3 176.59A20 20 0 0058 194.3l41.92-47.59a8 8 0 016-2.71zm59.7 32.59l-8.74-45A60 60 0 01172 160h-4.2l30.2 34.31a20.09 20.09 0 0017.46 5.39 20 20 0 0016.23-23.11z" />
  </svg>
)
export function IconNews() {
  return (
    <svg
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth=".7"
      stroke="currentColor">
      <path
        d="M22.75 24H5.25C3.51697 24 2.10075 22.6435 2.00514 20.9344L2 20.75V6.25C2 5.05914 2.92516 4.08436 4.09595 4.00519L4.25 4H19.75C20.9409 4 21.9156 4.92516 21.9948 6.09595L22 6.25V7H23.75C24.9409 7 25.9156 7.92516 25.9948 9.09595L26 9.25V20.75C26 22.483 24.6435 23.8992 22.9344 23.9949L22.75 24H5.25H22.75ZM5.25 22.5H22.75C23.6682 22.5 24.4212 21.7929 24.4942 20.8935L24.5 20.75V9.25C24.5 8.8703 24.2178 8.55651 23.8518 8.50685L23.75 8.5H22V19.25C22 19.6297 21.7178 19.9435 21.3518 19.9932L21.25 20C20.8703 20 20.5565 19.7178 20.5068 19.3518L20.5 19.25V6.25C20.5 5.8703 20.2178 5.55651 19.8518 5.50685L19.75 5.5H4.25C3.8703 5.5 3.55651 5.78215 3.50685 6.14823L3.5 6.25V20.75C3.5 21.6682 4.20711 22.4212 5.10647 22.4942L5.25 22.5H22.75H5.25ZM10.2465 13.0035C10.9369 13.0035 11.4965 13.5631 11.4965 14.2535V17.75C11.4965 18.4404 10.9369 19 10.2465 19H6.75C6.05964 19 5.5 18.4404 5.5 17.75V14.2535C5.5 13.5631 6.05964 13.0035 6.75 13.0035H10.2465ZM14.25 17.5H17.7462C18.1604 17.5 18.4962 17.8358 18.4962 18.25C18.4962 18.6297 18.214 18.9435 17.848 18.9932L17.7462 19H14.25C13.8358 19 13.5 18.6642 13.5 18.25C13.5 17.8703 13.7822 17.5565 14.1482 17.5068L14.25 17.5H17.7462H14.25ZM9.99653 14.5035H7V17.5H9.99653V14.5035ZM14.25 13.0035H17.7462C18.1604 13.0035 18.4962 13.3393 18.4962 13.7535C18.4962 14.1332 18.214 14.447 17.848 14.4966L17.7462 14.5035H14.25C13.8358 14.5035 13.5 14.1677 13.5 13.7535C13.5 13.3738 13.7822 13.06 14.1482 13.0103L14.25 13.0035H17.7462H14.25ZM6.2464 8.49666H17.7462C18.1604 8.49666 18.4962 8.83244 18.4962 9.24666C18.4962 9.62635 18.214 9.94015 17.848 9.98981L17.7462 9.99666H6.2464C5.83218 9.99666 5.4964 9.66087 5.4964 9.24666C5.4964 8.86696 5.77855 8.55317 6.14463 8.5035L6.2464 8.49666H17.7462H6.2464Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconBank() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const IconLock = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
  </svg>
)

export function IconMenu() {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    //   <path
    //     fill="currentColor"
    //     fillRule="evenodd"
    //     strokeWidth=".7"
    //     stroke="currentColor"
    //     d="M3 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1"
    //     clipRule="evenodd"
    //   />
    // </svg>

    <svg
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth=".2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM5 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm7-7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM5 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm7-7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM5 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" />
    </svg>
  )
}
export function IconClose() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="currentColor"
      strokeWidth="2.5"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  )
}
export function IconLang() {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth=".1"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="m9.563 7.505.056.117 5.307 13.005a1 1 0 0 1-1.802.86l-.05-.105L11.693 18H5.407l-1.49 3.407a1 1 0 0 1-1.208.555l-.11-.04a1 1 0 0 1-.556-1.208l.04-.11L7.778 7.6c.336-.77 1.394-.795 1.786-.094ZM19 2a1 1 0 0 1 .993.883L20 3v4h1a1 1 0 0 1 .993.883L22 8a1 1 0 0 1-.883.993L21 9h-1v7a1 1 0 0 1-.883.993L19 17a1 1 0 0 1-.993-.883L18 16V3a1 1 0 0 1 1-1ZM8.66 10.567 6.282 16h4.595L8.66 10.567ZM11 2h5a1 1 0 0 1 .993.883L17 3v2.975a4 4 0 0 1-4 4 1 1 0 1 1 0-2 2 2 0 0 0 1.995-1.85l.005-.15V4h-4a1 1 0 0 1-.117-1.993L11 2h5-5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const IconUser = () => (
  <svg
    fill="currentColor"
    strokeWidth=".1"
    stroke="currentColor"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg">
    <path d="m 20.366094,9.0158108 a 4.3660946,4.3660946 0 1 0 -8.732189,0 4.3660946,4.3660946 0 1 0 8.732189,0 m -11.3518448,0 a 6.9857511,6.9857511 0 1 1 13.9715008,0 6.9857511,6.9857511 0 1 1 -13.9715008,0 M 6.4655417,27.353408 H 25.534458 C 25.04873,23.898736 22.079787,21.240876 18.494131,21.240876 h -4.988263 c -3.5856541,0 -6.5545984,2.65786 -7.0403263,6.112532 m -2.6906059,0.998744 c 0,-5.375754 4.3551793,-9.730933 9.7309322,-9.730933 h 4.988263 c 5.375754,0 9.730933,4.355179 9.730933,9.730933 0,0.89505 -0.725863,1.620913 -1.620913,1.620913 H 5.3958485 c -0.8950494,0 -1.6209127,-0.725863 -1.6209127,-1.620913" />
  </svg>
)

export function IconAccessibility() {
  return (
    <svg
      viewBox="0 0 23.999999 23.999999"
      fill="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(1.3540617,0,0,1.3540617,-4.2487394,-4.0932779)">
        <path
          d="m 14,7 c 0,1.10457 -0.8954,2 -2,2 -1.1046,0 -2,-0.89543 -2,-2 0,-1.10457 0.8954,-2 2,-2 1.1046,0 2,0.89543 2,2 z"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <path
          d="m 18,10 c 0,0 -3.5373,1.5 -6,1.5 C 9.53727,11.5 6,10 6,10"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
        <path
          d="m 12,12 v 1.4522 m 0,0 c 0,0.5753 0.1654,1.1384 0.4765,1.6223 L 15,19 m -3,-5.5478 c 0,0.5753 -0.1654,1.1384 -0.4765,1.6223 L 9,19"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
export const IconOpenSource = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path fill="none" d="M0 0H24V24H0z" />
      <path
        stroke="currentColor"
        strokeWidth=".5"
        strokeLinecap="round"
        d="M12 2c5.523 0 10 4.477 10 10 0 4.4-2.841 8.136-6.789 9.473l-.226.074-2.904-7.55C13.15 13.95 14 13.054 14 12c0-1.105-.895-2-2-2s-2 .895-2 2c0 1.077.851 1.955 1.917 1.998l-2.903 7.549-.225-.074C4.84 20.136 2 16.4 2 12 2 6.477 6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8 0 2.92 1.564 5.475 3.901 6.872l1.48-3.849C8.534 14.29 8 13.207 8 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.207-.535 2.29-1.38 3.023.565 1.474 1.059 2.757 1.479 3.85C18.435 17.475 20 14.92 20 12c0-4.418-3.582-8-8-8z"
      />
    </g>
  </svg>
)

export function IconVisualSearch() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.2"
      stroke="currentColor">
      <path
        d="M17.75 3C19.5449 3 21 4.45508 21 6.25V9.25C21 9.66421 20.6642 10 20.25 10C19.8358 10 19.5 9.66421 19.5 9.25V6.25C19.5 5.2835 18.7165 4.5 17.75 4.5L14.75 4.5C14.3358 4.5 14 4.16421 14 3.75C14 3.33579 14.3358 3 14.75 3H17.75ZM6.25 3C4.45507 3 3 4.45507 3 6.25V9.25C3 9.66421 3.33579 10 3.75 10C4.16421 10 4.5 9.66421 4.5 9.25V6.25C4.5 5.2835 5.2835 4.5 6.25 4.5H9.25C9.66421 4.5 10 4.16421 10 3.75C10 3.33579 9.66421 3 9.25 3H6.25ZM17.75 21C19.5449 21 21 19.5449 21 17.75V14.75C21 14.3358 20.6642 14 20.25 14C19.8358 14 19.5 14.3358 19.5 14.75V17.75C19.5 18.7165 18.7165 19.5 17.75 19.5H14.75C14.3358 19.5 14 19.8358 14 20.25C14 20.6642 14.3358 21 14.75 21H17.75ZM3 17.75C3 19.5449 4.45507 21 6.25 21H9.25C9.66421 21 10 20.6642 10 20.25C10 19.8358 9.66421 19.5 9.25 19.5H6.25C5.2835 19.5 4.5 18.7165 4.5 17.75L4.5 14.75C4.5 14.3358 4.16421 14 3.75 14C3.33579 14 3 14.3358 3 14.75L3 17.75ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5ZM7.5 8.5C8.05229 8.5 8.5 8.05229 8.5 7.5C8.5 6.94772 8.05229 6.5 7.5 6.5C6.94772 6.5 6.5 6.94772 6.5 7.5C6.5 8.05229 6.94772 8.5 7.5 8.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconLanguage() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.2"
      stroke="currentColor">
      <path
        d="M12.7502 2C12.336 2 12.0002 2.33579 12.0002 2.75C12.0002 3.16421 12.336 3.5 12.7502 3.5H18.5002V6.30519C18.5002 8.0543 16.7512 9.5 14.7502 9.5C14.336 9.5 14.0002 9.83579 14.0002 10.25C14.0002 10.6642 14.336 11 14.7502 11C17.3137 11 20.0002 9.12567 20.0002 6.30519V2.75C20.0002 2.33579 19.6644 2 19.2502 2H12.7502ZM10.693 7.46282C10.5769 7.18263 10.3034 6.99997 10.0001 7C9.69682 7.00003 9.42339 7.18274 9.3073 7.46295L2.0573 24.963C1.89877 25.3457 2.08047 25.7844 2.46314 25.943C2.84582 26.1015 3.28455 25.9198 3.44309 25.5371L5.53071 20.498H14.4725L16.5613 25.5373C16.7199 25.9199 17.1587 26.1015 17.5413 25.9429C17.9239 25.7843 18.1056 25.3455 17.947 24.9629L15.7434 19.6469C15.7257 19.5153 15.6739 19.3946 15.5971 19.2938L10.693 7.46282ZM13.8507 18.998H6.15214L10.0004 9.70911L13.8507 18.998ZM22.2518 2C22.666 2 23.0018 2.33579 23.0018 2.75V8.5H25.2502C25.6644 8.5 26.0002 8.83579 26.0002 9.25C26.0002 9.66421 25.6644 10 25.2502 10H23.0018V19.2495C23.0018 19.6637 22.666 19.9995 22.2518 19.9995C21.8376 19.9995 21.5018 19.6637 21.5018 19.2495V9.29918C21.5007 9.28292 21.5002 9.26652 21.5002 9.25C21.5002 9.23348 21.5007 9.21708 21.5018 9.20082V2.75C21.5018 2.33579 21.8376 2 22.2518 2Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconSearch() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.5"
      stroke="currentColor">
      <path
        d="M13.5 3C7.70101 3 3 7.70101 3 13.5C3 19.299 7.70101 24 13.5 24C16.0394 24 18.3683 23.0985 20.1841 21.5981L27.293 28.7071C27.6836 29.0976 28.3167 29.0976 28.7073 28.7071C29.0978 28.3166 29.0978 27.6834 28.7073 27.2929L21.5983 20.1839C23.0986 18.3682 24 16.0393 24 13.5C24 7.70101 19.299 3 13.5 3ZM5 13.5C5 8.80558 8.80558 5 13.5 5C18.1944 5 22 8.80558 22 13.5C22 18.1944 18.1944 22 13.5 22C8.80558 22 5 18.1944 5 13.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconCheckOk() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  )
}
export function IconFeedback() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.59961 19.9203L7.12357 18.7012L7.13478 18.6926C7.45249 18.4384 7.61281 18.3101 7.79168 18.2188C7.95216 18.1368 8.12328 18.0771 8.2998 18.0408C8.49877 18 8.70603 18 9.12207 18H17.8031C18.921 18 19.4806 18 19.908 17.7822C20.2843 17.5905 20.5905 17.2842 20.7822 16.9079C21 16.4805 21 15.9215 21 14.8036V7.19691C21 6.07899 21 5.5192 20.7822 5.0918C20.5905 4.71547 20.2837 4.40973 19.9074 4.21799C19.4796 4 18.9203 4 17.8002 4H6.2002C5.08009 4 4.51962 4 4.0918 4.21799C3.71547 4.40973 3.40973 4.71547 3.21799 5.0918C3 5.51962 3 6.08009 3 7.2002V18.6712C3 19.7369 3 20.2696 3.21846 20.5433C3.40845 20.7813 3.69644 20.9198 4.00098 20.9195C4.35115 20.9191 4.76744 20.5861 5.59961 19.9203Z"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function IconLocationGps() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1"
      stroke="currentColor">
      <path
        d="M28.8612 5.72272C29.4833 4.10524 27.894 2.51596 26.2766 3.13807L4.28218 11.5975C2.47024 12.2943 2.61372 14.9042 4.49115 15.3983L13.514 17.7727C13.8626 17.8645 14.1348 18.1367 14.2266 18.4853L16.601 27.5081C17.0951 29.3856 19.7049 29.529 20.4018 27.7171L28.8612 5.72272ZM26.9945 5.00476L18.5351 26.9991L16.1607 17.9763C15.8855 16.9305 15.0688 16.1138 14.023 15.8386L5.00014 13.4641L26.9945 5.00476Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconHeart() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1"
      stroke="currentColor">
      <path
        d="M3.38563 7.13082C6.35842 2.96011 12.5531 2.95562 15.532 7.12201L15.9964 7.77164L16.4137 7.17921C19.3686 2.98397 25.5742 2.94256 28.5848 7.098C30.6822 9.99286 30.4377 13.9672 28.0014 16.5832L16.7343 28.6811C16.545 28.8844 16.2797 28.9997 16.0019 28.9995C15.7241 28.9994 15.4589 28.8836 15.2698 28.6801L3.99445 16.5399C1.58467 13.9453 1.33031 10.0143 3.38563 7.13082ZM13.905 8.28522C11.7246 5.23554 7.19026 5.23883 5.01426 8.29167C3.50982 10.4023 3.696 13.2797 5.4599 15.1789L16.0036 26.5312L26.5378 15.2201C28.3226 13.3037 28.5017 10.3921 26.9652 8.2714C24.7597 5.22719 20.2136 5.25752 18.0488 8.3309L16.8201 10.0754C16.6335 10.3403 16.3301 10.4984 16.0061 10.4995C15.682 10.5007 15.3775 10.3448 15.1891 10.0812L13.905 8.28522Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconStar() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1"
      stroke="currentColor">
      <path
        d="M12.7013 3.90984C13.2332 2.83213 14.7699 2.83214 15.3018 3.90984L17.9928 9.36237L24.01 10.2367C25.1993 10.4095 25.6742 11.8711 24.8136 12.71L20.4595 16.9542L21.4874 22.9471C21.6905 24.1316 20.4473 25.0349 19.3835 24.4756L14.0015 21.6462L8.61958 24.4756C7.55582 25.0349 6.31254 24.1316 6.5157 22.9471L7.54357 16.9542L3.18947 12.71C2.32887 11.8711 2.80376 10.4095 3.99308 10.2367L10.0103 9.36237L12.7013 3.90984ZM14.0015 4.66454L11.3438 10.0498C11.1326 10.4777 10.7243 10.7744 10.252 10.843L4.30903 11.7066L8.60941 15.8984C8.95115 16.2315 9.1071 16.7115 9.02642 17.1818L8.01124 23.1008L13.3268 20.3062C13.7492 20.0842 14.2539 20.0842 14.6763 20.3062L19.9918 23.1008L18.9767 17.1818C18.896 16.7115 19.0519 16.2315 19.3937 15.8984L23.6941 11.7066L17.7511 10.843C17.2788 10.7744 16.8705 10.4777 16.6593 10.0498L14.0015 4.66454Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconMoon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.1"
      stroke="currentColor">
      <path
        d="M13.8232 2.30045C13.667 2.48486 13.6093 2.73322 13.668 2.96761C14.3203 5.5684 14.7731 9.48625 13.0595 12.913C12.2013 14.6292 10.664 15.9331 8.89027 16.9159C7.12023 17.8966 5.16953 18.5267 3.57078 18.9201C3.3413 18.9766 3.15187 19.1379 3.05957 19.3555C2.96727 19.573 2.98291 19.8214 3.10176 20.0256C5.17924 23.5958 9.04884 25.9985 13.4805 25.9985C20.1079 25.9985 25.4805 20.6259 25.4805 13.9985C25.4805 7.69929 20.6274 2.53436 14.4557 2.03758C14.2148 2.01819 13.9794 2.11605 13.8232 2.30045ZM15.3623 3.66654C20.263 4.55307 23.9805 8.84197 23.9805 13.9985C23.9805 19.7975 19.2795 24.4985 13.4805 24.4985C9.96157 24.4985 6.84618 22.7678 4.94019 20.1085C6.40164 19.6919 8.0621 19.0896 9.61724 18.2279C11.5409 17.1621 13.3586 15.6685 14.4011 13.584C16.1176 10.1515 15.9022 6.37722 15.3623 3.66654Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconSun() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.1"
      stroke="currentColor">
      <path
        d="M16.0003 2C16.5525 2 17.0003 2.44772 17.0003 3V5C17.0003 5.55228 16.5525 6 16.0003 6C15.448 6 15.0003 5.55228 15.0003 5V3C15.0003 2.44772 15.448 2 16.0003 2ZM16.0003 23C19.8662 23 23.0003 19.866 23.0003 16C23.0003 12.134 19.8662 9 16.0003 9C12.1343 9 9.00025 12.134 9.00025 16C9.00025 19.866 12.1343 23 16.0003 23ZM16.0003 21C13.2388 21 11.0003 18.7614 11.0003 16C11.0003 13.2386 13.2388 11 16.0003 11C18.7617 11 21.0003 13.2386 21.0003 16C21.0003 18.7614 18.7617 21 16.0003 21ZM29.0003 17C29.5525 17 30.0003 16.5523 30.0003 16C30.0003 15.4477 29.5525 15 29.0003 15H27.0003C26.448 15 26.0003 15.4477 26.0003 16C26.0003 16.5523 26.448 17 27.0003 17H29.0003ZM16.0003 26C16.5525 26 17.0003 26.4477 17.0003 27V29.0005C17.0003 29.5528 16.5525 30.0005 16.0003 30.0005C15.448 30.0005 15.0003 29.5528 15.0003 29.0005V27C15.0003 26.4477 15.448 26 16.0003 26ZM5.00025 17C5.55254 17 6.00025 16.5523 6.00025 16C6.00025 15.4477 5.55254 15 5.00025 15H3C2.44772 15 2 15.4477 2 16C2 16.5523 2.44772 17 3 17H5.00025ZM5.29412 5.29368C5.68464 4.90316 6.31781 4.90316 6.70833 5.29368L8.70833 7.29368C9.09886 7.68421 9.09886 8.31737 8.70833 8.7079C8.31781 9.09842 7.68464 9.09842 7.29412 8.7079L5.29412 6.7079C4.9036 6.31737 4.9036 5.68421 5.29412 5.29368ZM6.70833 26.708C6.31781 27.0985 5.68464 27.0985 5.29412 26.708C4.9036 26.3175 4.9036 25.6843 5.29412 25.2938L7.29412 23.2938C7.68464 22.9032 8.31781 22.9032 8.70833 23.2938C9.09886 23.6843 9.09886 24.3175 8.70833 24.708L6.70833 26.708ZM26.7083 5.29368C26.3178 4.90316 25.6846 4.90316 25.2941 5.29368L23.2941 7.29368C22.9036 7.68421 22.9036 8.31737 23.2941 8.7079C23.6846 9.09842 24.3178 9.09842 24.7083 8.7079L26.7083 6.7079C27.0989 6.31737 27.0989 5.68421 26.7083 5.29368ZM25.2941 26.708C25.6846 27.0985 26.3178 27.0985 26.7083 26.708C27.0989 26.3175 27.0989 25.6843 26.7083 25.2938L24.7083 23.2938C24.3178 22.9032 23.6846 22.9032 23.2941 23.2938C22.9036 23.6843 22.9036 24.3175 23.2941 24.708L25.2941 26.708Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconList() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth=".8"
      stroke="currentColor"
      fill="currentColor">
      <path d="M12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5ZM12 16C12 16.8284 11.3284 17.5 10.5 17.5C9.67157 17.5 9 16.8284 9 16C9 15.1716 9.67157 14.5 10.5 14.5C11.3284 14.5 12 15.1716 12 16ZM10.5 23C11.3284 23 12 22.3284 12 21.5C12 20.6716 11.3284 20 10.5 20C9.67157 20 9 20.6716 9 21.5C9 22.3284 9.67157 23 10.5 23ZM14 10.5C14 9.94772 14.4477 9.5 15 9.5H22C22.5523 9.5 23 9.94772 23 10.5C23 11.0523 22.5523 11.5 22 11.5H15C14.4477 11.5 14 11.0523 14 10.5ZM15 15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H22C22.5523 17 23 16.5523 23 16C23 15.4477 22.5523 15 22 15H15ZM14 21.5C14 20.9477 14.4477 20.5 15 20.5H22C22.5523 20.5 23 20.9477 23 21.5C23 22.0523 22.5523 22.5 22 22.5H15C14.4477 22.5 14 22.0523 14 21.5ZM7.5 3C5.01472 3 3 5.01472 3 7.5V24.5C3 26.9853 5.01472 29 7.5 29H24.5C26.9853 29 29 26.9853 29 24.5V7.5C29 5.01472 26.9853 3 24.5 3H7.5ZM5 7.5C5 6.11929 6.11929 5 7.5 5H24.5C25.8807 5 27 6.11929 27 7.5V24.5C27 25.8807 25.8807 27 24.5 27H7.5C6.11929 27 5 25.8807 5 24.5V7.5Z" />
    </svg>
  )
}
export function IconCircles() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth=".4"
      stroke="currentColor"
      fill="currentColor">
      <path
        d="M13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8ZM11.125 8C11.125 9.72589 9.72589 11.125 8 11.125C6.27411 11.125 4.875 9.72589 4.875 8C4.875 6.27411 6.27411 4.875 8 4.875C9.72589 4.875 11.125 6.27411 11.125 8ZM25 8C25 5.23858 22.7614 3 20 3C17.2386 3 15 5.23858 15 8C15 10.7614 17.2386 13 20 13C22.7614 13 25 10.7614 25 8ZM23.125 8C23.125 9.72589 21.7259 11.125 20 11.125C18.2741 11.125 16.875 9.72589 16.875 8C16.875 6.27411 18.2741 4.875 20 4.875C21.7259 4.875 23.125 6.27411 23.125 8ZM8 25C5.23858 25 3 22.7614 3 20C3 17.2386 5.23858 15 8 15C10.7614 15 13 17.2386 13 20C13 22.7614 10.7614 25 8 25ZM8 23.125C9.72589 23.125 11.125 21.7259 11.125 20C11.125 18.2741 9.72589 16.875 8 16.875C6.27411 16.875 4.875 18.2741 4.875 20C4.875 21.7259 6.27411 23.125 8 23.125ZM25 20C25 17.2386 22.7614 15 20 15C17.2386 15 15 17.2386 15 20C15 22.7614 17.2386 25 20 25C22.7614 25 25 22.7614 25 20ZM23.125 20C23.125 21.7259 21.7259 23.125 20 23.125C18.2741 23.125 16.875 21.7259 16.875 20C16.875 18.2741 18.2741 16.875 20 16.875C21.7259 16.875 23.125 18.2741 23.125 20Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const IconFinance = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 7H4.6C4.03995 7 3.75992 7 3.54601 7.10899C3.35785 7.20487 3.20487 7.35785 3.10899 7.54601C3 7.75992 3 8.03995 3 8.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 4.6C9 4.03995 9 3.75992 9.10899 3.54601C9.20487 3.35785 9.35785 3.20487 9.54601 3.10899C9.75992 3 10.0399 3 10.6 3L13.4 3C13.9601 3 14.2401 3 14.454 3.10899C14.6422 3.20487 14.7951 3.35785 14.891 3.54601C15 3.75992 15 4.03995 15 4.6V21M15 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V19.4C21 19.9601 21 20.2401 20.891 20.454C20.7951 20.6422 20.6422 20.7951 20.454 20.891C20.2401 21 19.9601 21 19.4 21H15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export function IconApps() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth=".8"
      stroke="currentColor">
      <path
        d="M24.8079 2.95386C23.5387 1.68465 21.4809 1.68465 20.2117 2.95386L16.999 6.16657C16.9547 4.41019 15.517 2.99997 13.75 2.99997H6.25C4.45507 2.99997 3 4.45504 3 6.24997V25.75C3 27.5449 4.45507 29 6.25 29L25.75 29C27.5449 29 29 27.5449 29 25.75V18.25C29 16.4858 27.5944 15.0499 25.842 15.0012L29.0505 11.7927C30.3197 10.5235 30.3197 8.4657 29.0505 7.1965L24.8079 2.95386ZM19.1763 15H17V12.8237L19.1763 15ZM21.6259 4.36807C22.114 3.87991 22.9055 3.87991 23.3936 4.36807L27.6363 8.61071C28.1244 9.09887 28.1244 9.89032 27.6363 10.3785L23.3936 14.6211C22.9055 15.1093 22.114 15.1093 21.6259 14.6211L17.3832 10.3785C16.8951 9.89032 16.8951 9.09887 17.3832 8.61071L21.6259 4.36807ZM15 6.24997V15H5V6.24997C5 5.55961 5.55964 4.99997 6.25 4.99997H13.75C14.4404 4.99997 15 5.55961 15 6.24997ZM5 25.75V17H15V27H6.25C5.55964 27 5 26.4403 5 25.75ZM17 17H25.75C26.4404 17 27 17.5596 27 18.25V25.75C27 26.4403 26.4404 27 25.75 27H17V17Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconEye() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.2"
      stroke="currentColor">
      <path
        d="M28.0335 17.29C28.1635 17.72 28.5634 18 28.9933 18V17.99C29.0933 17.99 29.1832 17.98 29.2832 17.95C29.8131 17.79 30.113 17.24 29.9531 16.71C29.9231 16.61 26.6138 6 15.9961 6C5.3784 6 2.06911 16.61 2.03912 16.72C1.87915 17.25 2.17909 17.8 2.70897 17.96C3.23886 18.12 3.79874 17.82 3.9587 17.29C4.06868 16.91 6.88807 8 15.9961 8C25.1005 8 27.9114 16.9033 28.0335 17.29ZM12 18C12 15.7909 13.7909 14 16 14C18.2091 14 20 15.7909 20 18C20 20.2091 18.2091 22 16 22C13.7909 22 12 20.2091 12 18ZM16 12C12.6863 12 10 14.6863 10 18C10 21.3137 12.6863 24 16 24C19.3137 24 22 21.3137 22 18C22 14.6863 19.3137 12 16 12Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function IconText() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth="1"
      stroke="currentColor"
      fill="currentColor">
      <path d="m2.75,16.25h12.5c.41,0,.75.34.75.75,0,.38-.28.69-.65.74h-.1s-12.5,0-12.5,0c-.41,0-.75-.34-.75-.75,0-.38.28-.69.65-.74h.1s12.5,0,12.5,0H2.75Z" />
      <path d="m2.75,11.25h18.5c.41,0,.75.34.75.75,0,.38-.28.69-.65.74h-.1s-18.5,0-18.5,0c-.41,0-.75-.34-.75-.75,0-.38.28-.69.65-.74h.1s18.5,0,18.5,0H2.75Z" />
      <path d="m2.75,6.25h18.5c.41,0,.75.34.75.75,0,.38-.28.69-.65.74h-.1s-18.5,0-18.5,0c-.41,0-.75-.34-.75-.75,0-.38.28-.69.65-.74h.1s18.5,0,18.5,0H2.75Z" />
    </svg>
  )
}
export function IconLeaf() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      strokeWidth="1"
      stroke="currentColor">
      <path
        d="m5.57,27.88l2.68-2.58c2.07,1.76,4.74,2.84,7.67,2.89,6.74.12,12.3-5.24,12.42-11.98l.16-8.84c.03-1.86-1.45-3.39-3.3-3.43l-8.84-.16c-6.74-.12-12.3,5.24-12.42,11.98-.05,2.93.93,5.64,2.61,7.77l-2.68,2.58c-.49.47-.5,1.24-.03,1.73.47.49,1.24.5,1.73.03Zm.81-12.07c.1-5.39,4.55-9.68,9.94-9.59l8.84.16c.51,0,.92.43.91.94l-.16,8.84c-.1,5.39-4.55,9.68-9.94,9.59-2.26-.04-4.32-.84-5.95-2.16l7.85-7.57c.49-.47.5-1.24.03-1.73-.47-.49-1.24-.5-1.73-.03l-7.85,7.57c-1.26-1.68-1.98-3.77-1.94-6.02Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const IconDownload = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth=".5"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.25 20.5a.75.75 0 1 1 0 1.5l-13 .004a.75.75 0 1 1 0-1.5l13-.004ZM11.648 2.012l.102-.007a.75.75 0 0 1 .743.648l.007.102-.001 13.685 3.722-3.72a.75.75 0 0 1 .976-.073l.085.073a.75.75 0 0 1 .072.976l-.073.084-4.997 4.997a.75.75 0 0 1-.976.073l-.085-.073-5.003-4.996a.75.75 0 0 1 .976-1.134l.084.072 3.719 3.714L11 2.755a.75.75 0 0 1 .648-.743l.102-.007-.102.007Z"
      fill="currentColor"
    />
  </svg>
)
export const IconMore = () => (
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    stroke="currentColor"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="5" r="1"></circle>
    <circle cx="12" cy="19" r="1"></circle>
  </svg>
)
export const IconInfo = () => (
  <svg
    width="24"
    height="24"
    fill="currentColor"
    strokeWidth=".7"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12 1.999c5.524 0 10.002 4.478 10.002 10.002 0 5.523-4.478 10.001-10.002 10.001-5.524 0-10.002-4.478-10.002-10.001C1.998 6.477 6.476 1.999 12 1.999Zm0 1.5a8.502 8.502 0 1 0 0 17.003A8.502 8.502 0 0 0 12 3.5Zm-.004 7a.75.75 0 0 1 .744.648l.007.102.003 5.502a.75.75 0 0 1-1.493.102l-.007-.101-.003-5.502a.75.75 0 0 1 .75-.75ZM12 7.003a.999.999 0 1 1 0 1.997.999.999 0 0 1 0-1.997Z" />
  </svg>
)
export const IconThemeSystem = () => (
  <svg
    width="24"
    height="24"
    fill="currentColor"
    strokeWidth=".7"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M6.75 22a.75.75 0 0 1-.102-1.493l.102-.007h1.749v-2.498H4.25a2.25 2.25 0 0 1-2.245-2.096L2 15.752V5.25a2.25 2.25 0 0 1 2.096-2.245L4.25 3h15.499a2.25 2.25 0 0 1 2.245 2.096l.005.154v10.502a2.25 2.25 0 0 1-2.096 2.245l-.154.005h-4.25V20.5h1.751a.75.75 0 0 1 .102 1.494L17.25 22H6.75Zm7.248-3.998h-4l.001 2.498h4l-.001-2.498ZM19.748 4.5H4.25a.75.75 0 0 0-.743.648L3.5 5.25v10.502c0 .38.282.694.648.743l.102.007h15.499a.75.75 0 0 0 .743-.648l.007-.102V5.25a.75.75 0 0 0-.648-.743l-.102-.007Z" />
  </svg>
)
export const IconChevronDown = () => (
  <svg
    width="24"
    height="24"
    fill="currentColor"
    strokeWidth=".5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z" />
  </svg>
)
export const IconArrowRight = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.704 4.284a1 1 0 1 0-1.403 1.424L17.67 11H4a1 1 0 1 0 0 2h13.665L12.3 18.285a1 1 0 0 0 1.403 1.424l6.925-6.822a1.25 1.25 0 0 0 0-1.78l-6.925-6.823Z"
      fill="currentColor"
    />
  </svg>
)

export const IconX = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 77.44 80"
    fill="currentColor">
    <path d="m60.99,5h11.87l-25.95,29.65,30.52,40.35h-23.89l-18.71-24.47-21.42,24.47H1.53l27.75-31.71L0,5h24.5l16.92,22.37L60.99,5Zm-4.17,62.89h6.58L20.93,11.74h-7.07l42.95,56.16h0Z" />
  </svg>
)
export const IconGitHub = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor">
    <path
      className="svg"
      d="M12,.37A11.93,11.93,0,0,0,8.15,23.62c.59.08.81-.29.81-.58V21c-3.3.74-4-1.61-4-1.61A3,3,0,0,0,3.6,17.68c-1-.73.08-.73.08-.73A2.52,2.52,0,0,1,5.51,18.2a2.54,2.54,0,0,0,3.44,1H9a2.57,2.57,0,0,1,.74-1.61c-2.65-.3-5.43-1.33-5.43-6A4.51,4.51,0,0,1,5.51,8.44a4.17,4.17,0,0,1,.15-3.16S6.68,5,9,6.53a10.53,10.53,0,0,1,3-.37,13.33,13.33,0,0,1,3,.37c2.27-1.54,3.3-1.25,3.3-1.25a4.58,4.58,0,0,1,.14,3.16,4.71,4.71,0,0,1,1.25,3.23c0,4.62-2.79,5.57-5.43,5.86a2.84,2.84,0,0,1,.81,2.21V23c0,.29.22.66.81.58A12,12,0,0,0,24,12.25,12,12,0,0,0,12,.37Z"
    />
  </svg>
)

export const Icon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1"
    stroke="currentColor">
    <path
      d="M3 6.25C3 4.45507 4.45507 3 6.25 3H21.75C23.5449 3 25 4.45507 25 6.25V21.75C25 23.5449 23.5449 25 21.75 25H6.25C4.45507 25 3 23.5449 3 21.75V6.25ZM6.25 4.5C5.2835 4.5 4.5 5.2835 4.5 6.25V21.75C4.5 22.7165 5.2835 23.5 6.25 23.5H21.75C22.7165 23.5 23.5 22.7165 23.5 21.75V6.25C23.5 5.2835 22.7165 4.5 21.75 4.5H6.25Z"
      fill="currentColor"
    />
  </svg>
)
